import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnValue,
  returnUserContent,
  returnBlockValue,
} from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

const Block = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)
  const [getUserContents, setUserContents] = useAtom(userContents)

  return (
    <div
      className={Classnames('mx-auto opr-card opr-cardimage flex items-center')}
      style={{
        color: returnBlockValue('textcolor', 'design', opBlocks[block], design),
        marginBottom: `${returnBlockValue(
          'marginbottom',
          'design',
          opBlocks[block],
          design
        )}px`,
        maxWidth: '600px',
      }}
    >
      <div className="w-full">
        <img
          src={returnBlockValue('image', 'content', opBlocks[block], content)}
          className="w-full rounded-lg"
        />
        <h3 className="text-sm italic opacity-75 mt-2">
          {returnBlockValue('caption', 'content', opBlocks[block], content)}
        </h3>
      </div>
    </div>
  )
}

export default Block
